import { z } from 'zod';
import { IsoDateSchema } from './primitives.js';

export const FiscalPeriodStatusSchema = z.enum(['OPEN', 'CLOSED', 'LOCKED']);

export const FiscalPeriodSchema = z.object({
  id: z.number().int().positive(),
  label: z.string().min(1),
  startDate: IsoDateSchema,
  endDate: IsoDateSchema,
  status: FiscalPeriodStatusSchema,
  closedAt: z.number().int().nonnegative().nullable(),
  lockedAt: z.number().int().nonnegative().nullable(),
});

export const CreateFiscalPeriodRequestSchema = z.object({
  label: z.string().min(1).max(120),
  startDate: IsoDateSchema,
  endDate: IsoDateSchema,
});

export type FiscalPeriodDto = z.infer<typeof FiscalPeriodSchema>;
export type CreateFiscalPeriodRequest = z.infer<typeof CreateFiscalPeriodRequestSchema>;
export type FiscalPeriodStatusDto = z.infer<typeof FiscalPeriodStatusSchema>;
